export default {
    sun: 'อา.',
    mon: 'จ.',
    tues: 'อ.',
    wednes: 'พ.',
    thurs: 'พฤ.',
    fri: 'ศ.',
    satur: 'ส.'
}
